// extracted by mini-css-extract-plugin
export default {"textStyleWave":"statusLinks_textStyleWave__Jn-5B","wave":"statusLinks_wave__UpGKr"};